module.exports = __webpack_public_path__ + "img/no-network.707e2bf.png";